import Dexie from "dexie";

/** Single DB instance for the whole app */
export const db = new Dexie("pwa-app"); //AppDB
// do NOT call db.open() here

/**
 * You do NOT set stores here directly—schema + migrations live in schema.js
 * and are applied by the provider at startup so everything is centralized.
 */
